import type { JSX } from 'react';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'motion/react';

const COLS = ['col1', 'col2', 'col3'] as const;

export default function Why(): JSX.Element {
  const { t } = useTranslation();
  const reduce = useReducedMotion();

  return (
    <section id="why" className="border-rule border-b py-24 md:py-32">
      <div className="mx-auto max-w-[1240px] px-6">
        <div className="mb-14 flex flex-wrap items-end justify-between gap-8">
          <div>
            <div className="text-dim mb-[18px] font-mono text-[11px] tracking-[0.22em] uppercase">
              {t('why.eyebrow')}
            </div>
            <h2 className="m-0 max-w-[800px] font-sans text-[clamp(40px,5vw,72px)] leading-none font-semibold tracking-[-0.03em]">
              {t('why.headlineLine1')}
              <br />
              {t('why.headlineLine2')}
            </h2>
          </div>
          <div className="border-rule text-dim border-l pl-5 text-right font-mono text-[11px] tracking-[0.18em] uppercase">
            {t('why.metaLine1')}
            <br />
            {t('why.metaLine2')}
            <br />
            {t('why.metaLine3')}
          </div>
        </div>

        <div className="grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-12">
          {COLS.map((key, idx) => (
            <motion.div
              key={key}
              initial={reduce ? false : { opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={reduce ? { duration: 0 } : { duration: 0.5, delay: idx * 0.1 }}
            >
              <div className="text-orange mb-4 font-mono text-[11px] tracking-[0.22em] uppercase">
                {t(`why.${key}.num`)} —
              </div>
              <h3 className="mb-4 font-sans text-[28px] leading-tight font-semibold tracking-[-0.02em]">
                {t(`why.${key}.title`)}
              </h3>
              <p className="text-dim m-0 text-[15px] leading-[1.55]">{t(`why.${key}.body`)}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
